import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



const FeatureSection = () => {




    const { t, i18n } = useTranslation()





   


        return (
            <React.Fragment>
                <section className="section bg-features bg-light" id="features">
                    <div className="container">
                        <Row>
                            <Col className="col-lg-12">
                                <div className="title-heading mb-5">
                                    <h3 className="text-dark mb-1 font-weight-light text-uppercase">{t('features.label')}</h3>
                                    <div className="title-border-simple position-relative"></div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="align-items-center">
                            <Col lg="6">
                                <div className="features-content">
                                    <div className="features-icon">
                                        <i className="pe-7s-science text-primary"></i>
                                    </div>
                                    <h4 className="font-weight-normal text-dark mb-3 mt-4">{t('receipts_and_documents.label')}</h4>
                                    <p className="text-muted f-14">{t('receipts_text1.label')}</p>
                                    <p className="text-muted f-14">{t('receipts_text2.label')}.</p>
                                    
                                    
                                </div>
                            </Col>
                            <Col lg="6">
                                <div className="features-img mt-32">
                                    <img src="images/features-img/img-1.png" alt="" className="img-fluid mx-auto d-block" />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className="section bg-features">
                    <div className="container">
                        <Row className="align-items-center">
                            <Col lg="6">
                                <div className="features-img">
                                    <img src="images/features-img/airplane.png" alt="" className="w-75 img-fluid mx-auto d-block" />
                                </div>
                            </Col>
                            <Col lg="6">
                                <div className="features-content mt-32">
                                    <div className="features-icon">
                                        <i className="pe-7s-shuffle text-primary"></i>
                                    </div>
                                    <h4 className="font-weight-normal text-dark mb-3 mt-4">{t('travel_invoices.label')}</h4>
                                    <p className="text-muted f-14">{t('travel_invoices_text1.label')}</p>
                                    <p className="text-muted f-14">{t('travel_invoices_text2.label')}</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>

            </React.Fragment>
        );
    
}
export default FeatureSection;